// extracted by mini-css-extract-plugin
export default {"wrapper":"ResourceBlock_wrapper__WM2To"};